import * as React from "react";
import { createLink, LinkComponent } from "@tanstack/react-router";
import { Anchor, AnchorProps, NavLink, type NavLinkProps } from "@mantine/core";

interface MantineAnchorProps extends Omit<AnchorProps, "href"> {
  // Add any additional props you want to pass to the anchor
}

const MantineLinkComponent = React.forwardRef<
  HTMLAnchorElement,
  MantineAnchorProps
>((props, ref) => {
  return <Anchor ref={ref} {...props} />;
});

MantineLinkComponent.displayName = "MantineLinkComponent";

const CreatedLinkComponent = createLink(MantineLinkComponent);

export const TanstackMantineLink: LinkComponent<typeof MantineLinkComponent> = (
  props,
) => {
  return <CreatedLinkComponent preload="intent" {...props} />;
};

//
// NavLink component
//
interface MantineNavLinkProps extends Omit<NavLinkProps, "href"> {
  //
}

const MantineNavLinkComponent = React.forwardRef<
  HTMLAnchorElement,
  MantineNavLinkProps
>((props, ref) => {
  return <NavLink ref={ref} {...props} />;
});

MantineNavLinkComponent.displayName = "MantineNavLinkComponent";

const CreatedNavLinkComponent = createLink(MantineNavLinkComponent);

export const TanstackMantineNavLink: LinkComponent<
  typeof MantineNavLinkComponent
> = (props) => {
  return <CreatedNavLinkComponent preload="intent" {...props} />;
};
